"use client";

// src/input-otp-context.ts
import { createContext } from "@nextui-org/react-utils";
var [InputOtpProvider, useInputOtpContext] = createContext({
  name: "InputOtpContext",
  errorMessage: "useInputOtpContext: `context` is undefined. Seems like you forgot to wrap all input-otp components within `<InputOtp />`"
});

export {
  InputOtpProvider,
  useInputOtpContext
};
